import { Routes } from '@angular/router';
import { RoleGuard } from './core/auth/guards/role.guard';
import { ActionType } from './core/config/action.config';
import { NotAuthorizedComponent } from './views/not-authorized/not-authorized.component';
import { AuthGuard } from '@muvstok/ngx-muvstok';

export const routes: Routes = [
  {
    path: 'unavailable',
    loadComponent: () =>
      import('./views/unavailable/unavailable.component').then(
        (m) => m.UnavailableComponent,
      ),
  },
  {
    path: 'no-access',
    loadComponent: () =>
      import('./views/no-access/no-access.component').then(
        (m) => m.NoAccessComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'links',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/link/link.component').then((m) => m.LinkComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'lead-time',
        loadChildren: () =>
          import('./views/lead-time/lead-time.routes').then((m) => m.routes),
        data: { id: ActionType.LeadTime },
        canActivate: [RoleGuard],
      },
      {
        path: 'groups',
        loadChildren: () =>
          import('@muvstok/ngx-muvstok').then((m) => m.AUTOMAKER_GROUP_ROUTES),
        data: { id: ActionType.GrupoMontadora },
        canActivate: [RoleGuard],
      },
      {
        path: 'not-authorized',
        component: NotAuthorizedComponent,
      },
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      { path: '**', redirectTo: 'welcome', pathMatch: 'full' },
    ],
  },
];
